import { render, staticRenderFns } from "./RegisterMember.vue?vue&type=template&id=67931a46&scoped=true"
import script from "./RegisterMember.vue?vue&type=script&lang=js"
export * from "./RegisterMember.vue?vue&type=script&lang=js"
import style0 from "./RegisterMember.vue?vue&type=style&index=0&id=67931a46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67931a46",
  null
  
)

export default component.exports